import { StatusBar } from 'expo-status-bar';
import React from 'react';
import { StyleSheet, View, FlatList, Dimensions, TouchableHighlight, ActivityIndicator } from 'react-native';
import { Provider as PaperProvider } from 'react-native-paper';
import { Surface, Text, Headline, Paragraph, Divider } from 'react-native-paper';
import { NavigationContainer} from '@react-navigation/native';
import { createDrawerNavigator,
          DrawerContentScrollView,
          DrawerItemList,
          DrawerItem  } from '@react-navigation/drawer';
import * as Linking from 'expo-linking';
import { 
  useFonts,
  PlayfairDisplay_400Regular,
} from '@expo-google-fonts/playfair-display';
import { 
  Poppins_400Regular,
} from '@expo-google-fonts/poppins';
import { 
  OpenSans_300Light,
  OpenSans_300Light_Italic,
  OpenSans_400Regular,
  OpenSans_400Regular_Italic,
  OpenSans_600SemiBold,
  OpenSans_600SemiBold_Italic,
  OpenSans_700Bold,
  OpenSans_700Bold_Italic,
  OpenSans_800ExtraBold,
  OpenSans_800ExtraBold_Italic 
} from '@expo-google-fonts/open-sans'
import { Ionicons } from '@expo/vector-icons';






export default function App() {
  const [current,setCurrent] = React.useState([]);
  const [bus,setBus] = React.useState({});
  const [tech,setTech] = React.useState({});
  const [gen,setGen] = React.useState({});
  const [ent,setEnt] = React.useState({});
  const [health,setHealth] = React.useState({});
  const [spt,setSpt] = React.useState({});
  const [sci,setSci] = React.useState({});
  const [country, setCountry] = React.useState('us');
  const [category, setCategory] = React.useState('general');
  const [data, setData] = React.useState({});
  const [isLoaded,setisLoaded] = React.useState(false);
  const dimensions =  Dimensions.get('window');
  const [activeDrawer, setActiveDrawer] = React.useState([true,false,false,false,false,false,false])

  const styles = StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: '#f8f9fa',
      padding: 10,
    },
    load: {
      flex: 1,
      padding: 20,                         
      alignItems: 'center',
      justifyContent: 'center',
    },  
    surface: {
      flex: 1,
      flexDirection: 'column',
      padding: 20,                         
      alignItems: 'flex-start',
      justifyContent: 'center',
      elevation: 0,
      backgroundColor: '#fff',
      borderWidth: 0.1,
      borderColor: '#eeeeee',
      borderRadius: 1,
      margin: 10,
    },  
    headline: {
      color: '#000',
      fontSize: 23,
      fontFamily: 'PlayfairDisplay_400Regular',
    },
    summary: {
      color: '#000',
      fontSize: 14  ,
      marginTop: 10,
      fontFamily: 'OpenSans_400Regular',
    },
    read: {
      color: 'rgb(255, 51, 102)',
      fontSize: 15,
      fontFamily: 'OpenSans_400Regular',
    },
    drawerItem: {
      color: '#FFF',
      fontFamily: 'OpenSans_400Regular',
      fontSize: '1.25em'
    },
    drawerItemActive: {
      color: '#aaa',
      fontFamily: 'OpenSans_400Regular',
      fontSize: '1.25em'
    },
    navBar: {
      flex:1,
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      backgroundColor: '#f8f9fa',
    },
    drawerItemFooter: {
      color: '#FFF',
      fontFamily: 'OpenSans_400Regular',
      fontSize: '0.8em'
    },
    listHeader: {
      padding: 10,
      paddingBottom: 20,
      color: '#000',
      fontSize: '3em',
      fontFamily: 'PlayfairDisplay_400Regular',
      fontWeight: 'bold',
      alignSelf: 'center',
    },
    listHeaderM: {
      padding: 10,
      paddingBottom: 20,
      color: '#000',
      fontSize: '2em',
      fontFamily: 'PlayfairDisplay_400Regular',
      fontWeight: 'bold',
      alignSelf: 'center',
    }
  });

  const sentenceCase = (str) => { return str.replace(/[a-z]/i, function (letter) { return letter.toUpperCase(); }).trim(); }


  function CustomDrawerContent(props) {
    return (
      <DrawerContentScrollView {...props}>
        <View></View>
        <View> 
          <DrawerItemList {...props}/>
        </View> 
        <Divider/>
        <View></View>
        <View>
          <DrawerItem activeTintColor='#000' focused={activeDrawer[0]} labelStyle={[activeDrawer[0]? styles.drawerItemActive : styles.drawerItem]} label="General" onPress={() => changeNews('general')}/>
          <DrawerItem activeTintColor='#000' focused={activeDrawer[1]} labelStyle={[activeDrawer[1]? styles.drawerItemActive : styles.drawerItem]} label="Technology" onPress={() => changeNews('technology')}/>
          <DrawerItem activeTintColor='#000' focused={activeDrawer[2]} labelStyle={[activeDrawer[2]? styles.drawerItemActive : styles.drawerItem]} label="Business" onPress={() => changeNews('business')}/>
          <DrawerItem activeTintColor='#000' focused={activeDrawer[3]} labelStyle={[activeDrawer[3]? styles.drawerItemActive : styles.drawerItem]} label="Sports" onPress={() => changeNews('sports')}/>
          <DrawerItem activeTintColor='#000' focused={activeDrawer[4]} labelStyle={[activeDrawer[4]? styles.drawerItemActive : styles.drawerItem]} label="Entertainment" onPress={() => changeNews('entertainment')}/>
          <DrawerItem activeTintColor='#000' focused={activeDrawer[5]} labelStyle={[activeDrawer[5]? styles.drawerItemActive : styles.drawerItem]} label="Science" onPress={() => changeNews('science')}/>
          <DrawerItem activeTintColor='#000' focused={activeDrawer[6]} labelStyle={[activeDrawer[6]? styles.drawerItemActive : styles.drawerItem]} label="Health" onPress={() => changeNews('health')}/>
          <Divider/>
          <DrawerItem activeTintColor='#000' focused={0} labelStyle={styles.drawerItemFooter} label={(country === 'us')?"Change Country: US":"Change Country: IN"} onPress={() => changeCountry()}/>
          <DrawerItem activeTintColor='#000' focused={0} labelStyle={styles.drawerItemFooter} label="About" onPress={() => Linking.openURL('https://yashmundra.com')}/>
        </View> 
      </DrawerContentScrollView>
    );
  }

  const changeNews = (topic,c=country) => {
    setCategory(topic);
    switch (topic) {
      case 'general':
        setCurrent(gen[c]);
        setActiveDrawer([1,0,0,0,0,0,0])
        break;
      case 'technology':
        setCurrent(tech[c]);
        setActiveDrawer([0,1,0,0,0,0,0])
        break;
      case 'business':
        setCurrent(bus[c]);
        setActiveDrawer([0,0,1,0,0,0,0])
        break;
      case 'sports':
        setCurrent(spt[c]);
        setActiveDrawer([0,0,0,1,0,0,0])
        break;
      case 'entertainment':
        setCurrent(ent[c]);
        setActiveDrawer([0,0,0,0,1,0,0])
        break;
      case 'science':
        setCurrent(sci[c]);
        setActiveDrawer([0,0,0,0,0,1,0])
        break; 
      case 'health':
        setCurrent(health[c]);
        setActiveDrawer([0,0,0,0,0,0,1])
        break;                    
    }
  }

  const toTitleCase = (str) => {
      return str.replace(
          /\w\S*/g,
          function(txt) {
              return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
          }
      );
  }

  const changeCountry = () => {
    if(country === 'us'){
      setCountry('in');
      changeNews(category,'in');
    }else{
      setCountry('us');
      changeNews(category,'us');
    }
  }

  function News({navigation}){

    const renderItem = ({ item }) => {  
      return (
        <Surface style={styles.surface}>
          <Text style={styles.headline}>{item.headline}</Text>
          <Divider/>
          <Paragraph style={styles.summary}>{item.summary}</Paragraph>
          <Divider/>
          <TouchableHighlight underlayColor='#fff'onPress={()=> Linking.openURL(item.url)}>
          <Text style={styles.read}>Read More</Text>
          </TouchableHighlight>
        </Surface>
      );
    };

    const renderHeader = () => {
      return <Headline style={dimensions.width >= 768 ? styles.listHeader : styles.listHeaderM}>{sentenceCase(category)} News</Headline>
    }
  
    return (
      <View style={styles.container}>
          {!(dimensions.width >= 768) && 
          <View style={styles.navBar}>
            <TouchableHighlight style={{flex:1, marginLeft: 20,}}onPress={(() => {navigation.openDrawer();console.log(country)})}>
              <Ionicons name="md-menu" size={40} color="black" />
            </TouchableHighlight>
          </View>
          }
          <View style={{flex:15}}>
            <FlatList 
            data={current}
            renderItem={renderItem}
            numColumns={ dimensions.width >= 768 ? 2 : 1}
            keyExtractor={(item, index) => index.toString()}
            showsHorizontalScrollIndicator={false}
            ListHeaderComponent={renderHeader}
            />
          </View>
      </View>
    );
  }

  const fetchData = async() => {
    console.log('Run');
    await fetch('https://ghbjfa4gvl.execute-api.ap-south-1.amazonaws.com/Test/news-gen-api',{
      headers: {
        'x-api-key':'4S9VL5b4kv8sllRNcqNLl544it4ZizcG1KF4Fox8'
      },
    }).then(
      response => response.json()
    ).then(
      (result) => {
        setisLoaded(true);
        setData(result['Items'][0]);
        setGen(result['Items'][0]['general']);
        setBus(result['Items'][0]['business']);
        setTech(result['Items'][0]['technology']);
        setEnt(result['Items'][0]['entertainment']);
        setHealth(result['Items'][0]['health']);
        setSci(result['Items'][0]['science']);
        setSpt(result['Items'][0]['sports']);
        setCurrent(result['Items'][0][category][country])
      },
      (error) => {
        setisLoaded(true);
      }
    )
  }

  React.useEffect(()=>{
    fetchData();
  },[]);

  const Drawer = createDrawerNavigator();

  let [fontsLoaded] = useFonts({
    Poppins_400Regular,
    PlayfairDisplay_400Regular,
    OpenSans_400Regular,
  });

  function Loading () {
    return (
      <View style={styles.load}>
      <ActivityIndicator color='rgb(255, 51, 102)'size="large" />
      </View>
    )
  }

  if (!fontsLoaded || !isLoaded) {
    return <Loading/>;
  } else {
  return (
  <PaperProvider> 
    <NavigationContainer>
        <Drawer.Navigator drawerType={ dimensions.width >= 768 ? 'permanent' : 'slide'} 
          drawerContent={props => <CustomDrawerContent {...props} />}
          drawerContentOptions={{
            contentContainerStyle:{
              flex:1, flexDirection: 'column', justifyContent: 'space-around',
            },
            activeTintColor: '#FFF',
            activeBackgroundColor: '#000',
            labelStyle:{
              fontSize: '3em',
              fontFamily:'PlayfairDisplay_400Regular'
            }
          }}
          drawerStyle={{
            backgroundColor: '#000',
          }}
          >
          <Drawer.Screen name="Daily Brief" component={News} />  
        </Drawer.Navigator>      
    </NavigationContainer>
  </PaperProvider>
  );
}
}


